import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux';

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { colorPrimary, sidebarBg, sidebarActiveBg, sidebarText } = useSelector(
    (state: RootState) => state.theme.customTokens
  );

  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: {
          colorPrimary: colorPrimary,
          colorLink: colorPrimary,
          colorTextLightSolid: '#ffffff',
          colorTextDisabled: '#8c8c8c',
          colorBgContainerDisabled: '#f5f5f5',
          borderRadius: 6,
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        },
        components: {
          Layout: {
            siderBg: sidebarBg,
          },
          Menu: {
            darkItemBg: sidebarBg,
            darkItemSelectedBg: sidebarActiveBg,
            darkItemColor: sidebarText,
          },
        },
      }}
    >
      <style>{`
        :root {
          --sidebar-bg: ${sidebarBg};
          --sidebar-active-bg: ${sidebarActiveBg};
          --sidebar-text: ${sidebarText};
          --color-primary: ${colorPrimary};
        }

        .ant-btn-primary:not(:disabled):not(.ant-btn-disabled) {
          color: #ffffff !important;
        }

        .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover,
        .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):focus {
          color: #ffffff !important;
        }

        .ant-btn:disabled,
        .ant-btn[disabled],
        .ant-btn.ant-btn-disabled,
        .ant-btn-primary:disabled,
        .ant-btn-primary[disabled],
        .ant-btn-primary.ant-btn-disabled {
          color: #8c8c8c !important;
          background: #f5f5f5 !important;
          border-color: #d9d9d9 !important;
          text-shadow: none !important;
          box-shadow: none !important;
        }

        .ant-btn:disabled .anticon,
        .ant-btn[disabled] .anticon,
        .ant-btn.ant-btn-disabled .anticon {
          color: #8c8c8c !important;
        }
      `}</style>
      {children}
    </ConfigProvider>
  );
};
